export function dashToSnakeCase(str) {
  return str
    .split('-')
    .map((part, index) => {
      return index ? part[0].toUpperCase() + part.slice(1) : part;
    })
    .join('');
}



// WEBPACK FOOTER //
// ./utils/strings.ts